<template>
    <!-- <v-app-bar app flat color="transparent"> -->
    <!-- App bar - default height : 48px -->
    <v-app-bar
        app
        dense
        :hide-on-scroll="$vuetify.breakpoint.smAndUp"
        style="overflow: hidden"
        height="56px"
    >
        <!-- elevate-on-scroll -->
        <!-- Burger menu Button -->
        <v-app-bar-nav-icon
            v-if="!showSearchInXS"
            class="hidden-sm-and-up"
            @click="$emit('clicked', 1)"
        />

        <!-- Fitst line -->
        <v-container class="pa-0">
            <v-row no-gutters align="baseline" class="flex-nowrap">
                <template v-if="!showSearchInXS">
                    <!-- Main Logo Button -->
                    <v-toolbar-title class="mx-1">
                        <router-link to="/" class="text-decoration-none text-h5 font-weight-bold">
                            <img
                                class="d-none d-sm-inline d-md-none"
                                style="vertical-align: middle; transform: translateY(-1px); width: 32px;"
                                src="@/assets/img/repttown_logo.svg"
                                alt="Home"
                            />
                            <img 
                                style="width: 142px;"
                                class="hidden-sm-only"
                                src="@/assets/img/repttown_text.svg"
                                alt="Home"
                            />
                        </router-link>
                    </v-toolbar-title>

                    <v-btn
                        v-for="(menu, i) in menus"
                        :key="i"
                        text
                        :ripple="false"
                        class="px-3 ml-1 primary--text hidden-xs-only"
                        :to="`/${menu.path}`"
                        >{{ $langs.get(`gen.${menu.path}`) }}</v-btn
                    >

                    <v-spacer></v-spacer>
                </template>

                <!-- Search Items Field -->
                <SearchBar v-model="showSearchInXS"/>

                <!-- Cart Menu -->
                <!-- <CartMenu /> -->

                <v-divider vertical inset class="mx-1 primary--text"></v-divider>

                <!-- Login / Sign up Button -->
                <v-btn v-if="!isLogin" text small :ripple="false" class="primary--text px-1 align-self-center" to="/login">
                    {{ $langs.get(`auth.login`) }}<span class="hidden-xs-only">/{{ $langs.get(`auth.signup`) }}</span>
                </v-btn>

                <!-- User Menu | Logout Button -->
                <UserMenu v-if="isLogin"/>
            </v-row>
        </v-container>
        
        <!-- Second Line -->
        <!-- <template v-slot:extension v-if="$vuetify.breakpoint.name != 'xs'">
            <v-container class="pa-0">
                <v-row no-gutters align="center" class="flex-nowrap">
                    <v-btn
                        v-for="(menu, i) in menus"
                        :key="i"
                        text
                        :ripple="false"
                        class="px-3 mr-1 primary--text"
                        :to="`/${menu.path}`"
                        >{{ $langs.Gen[menu.path][$langs.lang] }}</v-btn
                    >

                    <v-spacer></v-spacer>

                    <v-btn
                        text
                        :ripple="false"
                        class="px-3 mr-2 primary--text"
                        to="/manual"
                        ><v-icon left small>mdi-book-open-variant</v-icon> {{ $langs.Gen.manual[$langs.lang] }}</v-btn
                    >
                    <v-btn
                        dark
                        depressed
                        large
                        :ripple="false"
                        class="px-4 mr-3 rounded-0 subtitle-2 primary darken-2 hidden-sm-and-down"
                        style="transform: translateY(0px)"
                        to="/mystore/product"
                        >{{ $langs.Gen.sellWithUs[$langs.lang] }}</v-btn
                    >
                </v-row>
            </v-container>
        </template> -->
    </v-app-bar>
</template>

<script>
// import ShopMenu from "./Submenus/ShopMenu";
import UserMenu from "./Submenus/UserMenu";
import CartMenu from "./Submenus/CartMenu";
import SearchBar from "./Submenus/SearchBar";

export default {
    components: {
        // ShopMenu,
        UserMenu,
        CartMenu,
        SearchBar
    },
    data() {
        return {
            menus: [
                { title: "Animals", path: "animals" },
                { title: "Petfoods", path: "petfoods" },
                { title: "Supplies", path: "supplies" },
                { title: "Store", path:"stores"},
            ],
            showSearchInXS: false,
        };
    },
    computed: {
        tabActive() {
            return this.menus.map((x) => x.path).includes(this.$route.path);
        },
        isLogin() {
            return (
                this.$store.getters["isLogged"]
            );
        },
    },
};
</script>

<style scoped>
.tab-main {
    font-weight: bolder !important;
}
.tab-main:not(.v-tab--active) {
    color: black !important;
}
</style>